/**
 * Chess pieces as little vector drawings. The old board used the Unicode chess characters, which some phones (iPhone, many Androids)
 * draw as flat emoji – so the black and white pieces could not be told apart. These drawings look the same everywhere and have a clear
 * white / dark colour scheme, a soft shadow and a shine.
 */
const PATHS: Record<string, string[]> = {
  // each piece is drawn in a 100×100 box, standing on a common base
  p: [
    "M50 20 a11 11 0 1 1 -0.01 0 z",
    "M40 42 h20 q3 3 3 6 q-2 4 -6 6 q5 10 8 22 h8 v8 h-44 v-8 h8 q3 -12 8 -22 q-4 -2 -6 -6 q0 -3 3 -6 z",
  ],
  r: [
    "M28 20 h10 v7 h8 v-7 h8 v7 h8 v-7 h10 v22 l-8 6 v22 l8 8 v10 h-44 v-10 l8 -8 v-22 l-8 -6 z",
  ],
  b: [
    "M50 9 a5 5 0 1 1 -0.01 0 z",
    "M50 17 C64 26 68 40 59 52 C65 58 66 66 62 73 L70 80 V90 H30 V80 L38 73 C34 66 35 58 41 52 C32 40 36 26 50 17 z",
  ],
  n: [
    "M30 90 V80 C30 66 40 56 45 46 C38 47 30 52 24 57 L21 50 C27 40 34 28 47 20 L50 11 L57 19 C72 24 80 42 77 62 C76 72 77 81 77 90 z",
  ],
  q: [
    "M22 31 a5 5 0 1 1 -0.01 0 z", "M38 22 a5 5 0 1 1 -0.01 0 z", "M50 16 a5 5 0 1 1 -0.01 0 z", "M62 22 a5 5 0 1 1 -0.01 0 z", "M78 31 a5 5 0 1 1 -0.01 0 z",
    "M30 90 L24 38 L38 56 L37 30 L46 56 L50 24 L54 56 L63 30 L62 56 L76 38 L70 90 z",
  ],
  k: [
    "M45 6 h10 v8 h8 v10 h-8 v6 h-10 v-6 h-8 v-10 h8 z",
    "M50 30 C62 30 72 36 70 46 C69 52 64 55 62 58 C70 64 72 78 70 90 H30 C28 78 30 64 38 58 C36 55 31 52 30 46 C28 36 38 30 50 30 z",
  ],
};
/** extra details drawn on top of the shape (eye, mitre cut, collar…) */
const DETAILS: Record<string, string[]> = {
  p: [],
  r: ["M34 48 h32", "M34 70 h32"],
  b: ["M45 36 l10 10"],
  n: ["!M60 33 a2.6 2.6 0 1 1 -0.01 0 z", "M24 58 l6 -2"],
  q: ["M36 78 h28"],
  k: ["M36 78 h28", "M40 46 h20"],
};
const BASE = "M24 90 h52 v7 h-52 z";

export function Piece({ type, white, size }: { type: string; white: boolean; size?: number | string }) {
  const t = type.toLowerCase();
  const shapes = PATHS[t] ?? [];
  const details = DETAILS[t] ?? [];
  return (
    <svg className={`cp ${white ? "cw" : "cb"}`} viewBox="0 0 100 100" width={size} height={size} aria-hidden="true" focusable="false">
      <g className="cp-shape">
        <path d={BASE} />
        {shapes.map((d, i) => <path key={i} d={d} />)}
      </g>
      <g className="cp-detail">
        {details.map((d, i) => (d.startsWith("!") ? <path key={i} className="fill" d={d.slice(1)} /> : <path key={i} d={d} fill="none" />))}
      </g>
      <path className="cp-shine" d="M32 88 C32 70 38 54 48 40" fill="none" />
    </svg>
  );
}
